import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

const GRADIENT_MAP: Record<number, string> = {
  1: 'var(--sime-gradient-1)',
  2: 'var(--sime-gradient-2)',
  3: 'var(--sime-gradient-3)',
  4: 'var(--sime-gradient-4)',
};

interface NeuCardProps extends HTMLAttributes<HTMLDivElement> {
  pressed?: boolean;
  glass?: boolean;
  topAccent?: 1 | 2 | 3 | 4;
  children: ReactNode;
}

export function NeuCard({ pressed = false, glass = false, topAccent, children, className, style, ...props }: NeuCardProps) {
  return (
    <div
      className={cn(
        'rounded-2xl p-4 md:p-6 transition-shadow duration-250',
        glass ? 'glass-panel' : 'bg-sime-surface',
        pressed
          ? 'shadow-neu-pressed'
          : glass
            ? 'shadow-neu-sm'
            : 'shadow-neu-raised',
        topAccent && 'glass-top-accent',
        className,
      )}
      style={{
        ...style,
        ...(topAccent ? { '--_accent-gradient': GRADIENT_MAP[topAccent] } as React.CSSProperties : undefined),
      }}
      {...props}
    >
      {children}
    </div>
  );
}
